import React from 'react';
import { PlacementFetchingProvider } from '@atlassian/post-office-placement-data';
import { postOfficePlacementFetch } from './preload-placement';

export const PlacementFetchProvider: React.FC<{
	children: React.ReactNode;
}> = ({ children }) => {
	return (
		<PlacementFetchingProvider fetch={postOfficePlacementFetch}>
			{children}
		</PlacementFetchingProvider>
	);
};
